var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32367",
    "data-name": "Group 32367",
    transform: "translate(-391 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_732",
    "data-name": "Ellipse 732",
    transform: "translate(391 35)",
    fill: "#f2f2f2",
    stroke: "#ebebeb",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31766",
    "data-name": "Group 31766",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_733",
    "data-name": "Ellipse 733",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(396 47)",
    fill: "rgb(112, 112, 112, 70%)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_734",
    "data-name": "Ellipse 734",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(403 47)",
    fill: "rgb(112, 112, 112, 70%)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_735",
    "data-name": "Ellipse 735",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(410 47)",
    fill: "rgb(112, 112, 112, 70%)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/option.9a8858c874265850829409f3dd2f71b5.svg";
export { ForwardRef as ReactComponent };